import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import "../../common.css";
import "../../investorAcademy.css";



const Dividends = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='share_capital Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Volatility</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>How are Warrants priced?</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Dividends</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>Interest Rates</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css"/>*/}
                                        <title>Dividends</title>
                                        <div className="contentbox">
                                            <p>Although warrant holders do not receive dividends, they will not be disadvantaged in this respect as forecast dividend are already priced into the warrant. As such, call warrants will not fall in price if the underlying shares fall by the dividend amount on the ex-div date.
                                                <br /><br />
                                                Similarly, put warrants will not increase in price in such a scenario. If however, there is a change in the forecast dividend announced on the stock, where the actual dividend comes in higher than the amount forecasted in the warrant, this can lead to a drop in the price of a call warrant and an increase in the put. Corporate actions (such as special dividends, capital repayments, share splits and rights issues) are treated separately and adjustments will be made to the warrant terms.</p>
                                            <div className="imgholder11">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/dividends (1).png' alt="image" />
                                            </div>
                                            <div className="imgholder imgmask2">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/ir_m.png' alt="image" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                  <div className='copyright_sec'>
                  Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                  </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/how-are-warrant-priced/interest-rates">
                                                Interest Rates
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                <Link to="/edu/how-are-warrant-priced/interest-rates">
                                    <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                <Link to="/edu/how-are-warrant-priced/volatility">
                                    <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/how-are-warrant-priced/volatility">
                                                Volatility
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default Dividends;